var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/play.5d5f5d84.png","uri@2x": __webpack_public_path__ + "static/media/play.77e0c3f0.png","uri@3x": __webpack_public_path__ + "static/media/play.346788e1.png",
    width: 44,
    height: 50
});